/**
 * Compares 2 arrays with checking if each value is strictly equal to the corresponding value.
 * @param a The array to compare.
 * @param b The array to compare.
 */
export const arrayEquals = <T>(a: Array<T>, b: Array<T>): boolean => {
  return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
};
